<template>
  <div class="service">
    <a class="service-contact" href="javascript:;" onclick='easemobim.bind({tenantId: "25128",hide: true})'><i class="icon-contact"></i></a>
    <a class="service-message" v-on:click="leaveMsg"><i class="icon-write"></i></a>
  </div>
</template>

<script>
  export default {
    name: "Service",
    props: [],
    data: function () {
      return {

      }
    },
    methods: {
      leaveMsg : function () {
        Vue.showModal('feedback');
      }
    },
    created: function () {
      console.info('service-init');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Service.vue